import { Constants } from '../constants/constants';
import { Component, OnInit } from '@angular/core';

import { EstructuraControlService } from '../servicios/estructura-control.service';
import { SetFormService } from '../servicios/set-form.service';
import { FormTextbox } from '../model-form/form-textbox';
import { FormDropdown } from '../model-form/form-dropdown';
import { EstructuraBase } from '../model-form/estructura-base';
import { Utils } from '../utils/utils';


@Component({
  selector: 'app-modificausuario',
  templateUrl: './modificausuario.component.html',
  styleUrls: ['./modificausuario.component.css']
})
export class ModificausuarioComponent implements OnInit {

  items: EstructuraBase<any>[];
  descripcion: string;
  idFormulario = 20;
  parametrosDestino: any[] = [];
  procedimientoDestino: string = "";

  constructor(
    servicioFormulario: SetFormService,
    public ruta: Utils,
    private formatFormulario: Utils
  ) {
    //this.destino=Constants.URL_USUARIO;
    this.descripcion = "Modificación De Usuario";
    let arrayDatos = [];
    servicioFormulario.getFormulario(this.idFormulario)
      .subscribe((data) => {
        //arrayDatos = this.formatFormulario.formatFormulario(data);
        this.items = arrayDatos;
        console.log(JSON.stringify(this.parametrosDestino));
        return this.items.sort((a, b) => a.order - b.order);
      })
  }

  ngOnInit() {
    this.ruta.setRuta();
  }

}
